import { useEffect } from "react";
import { IconCircleCheck } from "@tabler/icons-react";
import styles from "./toast.module.css";

export const Toast = ({ message, visible, onDismiss }) => {
  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(onDismiss, 4000);
    return () => clearTimeout(t);
  }, [visible, onDismiss]);

  return (
    <div
      className={`${styles.toast} ${visible ? styles.show : ""}`}
      role="status"
      aria-live="polite"
    >
      <IconCircleCheck size={18} />
      <span>{message}</span>
    </div>
  );
};

export const ToastMessage = ({ text, message }) => (
  <div>
    <p>{text}</p>
    <p> {message}</p>
  </div>
);
